<template>
    <div class="condition-plugins-compare">
        <single-select
            v-if="!multiple"
            :valid="valid"
            :clazz="'condition-popper'"
            :disabled="disabled"
            :value="currentValue"
            :placeholder="placeholder"
            :options="currentOptions"
            @input="onChange"
        />
        <multiple-select
            v-if="multiple"
            :valid="valid"
            :value="selected"
            title=""
            :select-type="selectType"
            :close="false"
            :show-select-num="true"
            :tag-formatter="tagFormatter"
            :placeholder="placeholder"
            :options="currentOptions"
            @input="onChange"
        />
    </div>
</template>

<script>
/**
 * 下拉选择聚合组件
 * - 包含单选和多选
 * - 提供了部分预设
 * - 可以自定义设置[todo]
 */
import SingleSelect from '@/components/single-select';
import MultipleSelect from '@/components/multiple-select';
import dataSource from './config';

export default {
  name: 'CompareSelector',

  components: {
    SingleSelect,
    MultipleSelect,
  },

  props: {
    valid: {
      type: Boolean,
      default: true,
    },
    // 传入值
    value: {
      type: [Number, String, Array, Object],
      default() {
        return null;
      },
    },
    tagFormatter: {
      type: Function,
      default: null,
    },
    // 传入的列表配置
    options: {
      type: Array,
      default() {
        return null;
      },
    },
    // 选框类型，设置已有的预选配置，如果没有传递该值会给一个报错的配置
    type: {
      type: String,
      default: 'ERROR',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 设置多选还是单选
    multiple: {
      type: Boolean,
      default: false,
    },
    selectType: {
      type: String,
      default: 'checkbox',
    },
    // 设置缺省提示
    placeholder: {
      type: String,
      default: '',
    },
  },

  data() {
    let currentValue;
    let selected = [];
    if (this.multiple) {
      selected = this.value || [];
    } else {
      currentValue = this.value;
    }
    return {
      currentOptions: this.options || dataSource[this.type] || dataSource.ERROR,
      currentValue,
      selected,
    };
  },

  watch: {
    value: {
      deep: true,
      handler(newValue) {
        if (this.multiple) {
          this.selected = newValue;
        } else {
          this.currentValue = newValue;
        }
      },
    },
    options(newValue) {
      this.currentOptions = newValue;
    },
  },

  created() {},

  methods: {
    validate() {
      if (this.multiple) {
        return this.$refs.multiple.validate();
      }
      return this.$refs.single.validate();
    },
    onChange(value, selectedTree) {
      console.log('compare-selector', value);
      if (this.multiple) {
        this.selected = value;
      } else {
        this.currentValue = value;
      }
      if (this.selectType === 'tree') {
        this.$emit('change', value, selectedTree);
      } else {
        this.$emit('change', value);
      }
    },
  },
};
</script>

<style lang="less">
.condition-plugins-compare {
    display: inline-block;
    margin-right: 15px;
    vertical-align: top;
}
</style>
